const toResponse = (response) => {
  const contactsResults = response.contacts.map(contact => ({
    contactName: `${contact.firstName || ''} ${contact.lastName || ''}`,
    firstName: contact.firstName,
    lastName: contact.lastName,
    contactPhone: contact.phone,
    email: contact.email,
    contactId: contact.contactId,
  }));

  const accountInfo = {
    companyName: response.account?.companyName,
    companyPhone: response.account?.phone,
    accountId: response.account?.accountId,
    streetAddress: response.account?.shippingAddress?.street,
    city: response.account?.shippingAddress?.city,
    state: response.account?.shippingAddress?.state,
    zipCode: response.account?.shippingAddress?.postalCode,

  };

  return {
    contacts: contactsResults,
    account: accountInfo,
  }
}

export default toResponse;